import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import { connect } from 'react-redux'
import * as actions from '../../store/actions'
import WyborStrukturyStyle from '../../styles/WyborStrukturyStyle'
import WyborStrukturyRowStyle from '../../styles/WyborStrukturyRowStyle'
import NazwaStruktury from '../NazwaStruktury'

const getKodSprawozdania = kod => {
  switch (kod) {
    case 'SFJINZ (1)':
      return 'SprFinJednostkaInnaWZlotych'
    case 'SFJMAZ (1)':
      return 'SprFinJednostkaMalaWZlotych'
    case 'SFJMIZ (1)':
      return 'SprFinJednostkaMikroWZlotych'
    case 'SFJOPZ (1)':
      return 'SprFinOpWZlotych'
    case 'SFJINT (1)':
      return 'SprFinJednostkaInnaWTysiacach'
    case 'SFJMAT (1)':
      return 'SprFinJednostkaMalaWTysiacach'
    case 'SFJMIT (1)':
      return 'SprFinJednostkaMikroWTysiacach'
    case 'SFJOPT (1)':
      return 'SprFinOpWTysiacach'
    case 'SFSINZ (1)':
      return 'SprFinSkonsolidowanaJednostkaInnaWZlotych'
    case 'SFSINT (1)':
      return 'SprFinSkonsolidowanaJednostkaInnaWTysiacach'
    case 'SFDMAZ (1)':
      return 'SprFinDomMaklerskiWZlotych'
    case 'SFDMAT (1)':
      return 'SprFinDomMaklerskiWTysiacach'
    default:
      return ''
  }
}

class WyborStruktury extends Component {
  render() {
    const { availableStructures, onSetStructure, dataSporzadzenia } = this.props
    return (
      <>
        <WyborStrukturyStyle>
          <div className="header">
            <div>
              <span className="high-headline-5">
                DOSTĘPNE STRUKTURY E-SPRAWOZDAŃ
              </span>
              {'  '}
              <span className="medium-emphasis-subtitle-2">
                (DLA DATY SPORZĄDZENIA: {dataSporzadzenia})
              </span>
            </div>
            <Button
              color="primary"
              variant="outlined"
              onClick={() => {
                onSetStructure(null, null)
              }}
            >
              WRÓĆ
            </Button>
          </div>
          <WyborStrukturyRowStyle className="container">
            {availableStructures
              ? availableStructures.map(element => (
                  <WyborStrukturyRowStyle key={element.priorytet}>
                    <main
                      data-cy="wybor-struktury"
                      className={
                        'row ' + getKodSprawozdania(element.kod.KodSystemowy)
                      }
                      onClick={() => onSetStructure(element.kod)}
                    >
                      <div className="nazwaStruktury">
                        <NazwaStruktury
                          wybor={true}
                          KodSprawozdania={getKodSprawozdania(
                            element.kod.KodSystemowy,
                          )}
                        />
                      </div>
                      <div className="version">
                        <span className="disabled-caption">WERSJA SCHEMY</span>
                        <span className="medium-emphasis-body-2">
                          {element.kod.WersjaSchemy}
                        </span>
                      </div>
                    </main>
                  </WyborStrukturyRowStyle>
                ))
              : null}
          </WyborStrukturyRowStyle>
        </WyborStrukturyStyle>
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    dataSporzadzenia: state.sprawozdanie.dataSporzadzenia,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSetStructure: struktura => dispatch(actions.setStructure(struktura)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WyborStruktury)
